<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
	export default{
		data(){
			return{
				
			}
		},
		created(){
			
		},
		methods:{
			
		},
	}
</script>
<style lang="scss" type="text/scss">
@import "style/common";
@import "style/func";
@import "style/media";
@import url('style/gg.css');

* {
  margin: 0;
  padding: 0;
}

</style>
<style>
	html,
	body,
	#app {
	  width: 100%;
	  /* height: 100%; */
	  background-color: #FFFFFF;
	  font-family:"Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",华文细黑,STHeiti,MingLiu;
	  /* overflow-x: hidden; */
	}
</style>